module.exports = __webpack_public_path__ + "img/FR20041.c8812d58.png";